import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'vw-flag-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-flag-icon lucide-flag">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
      <line x1="4" x2="4" y1="22" y2="15"/>
    </svg>`
})
export class FlagIconComponent {

}
